import * as React from "react";
import { FormSection } from "./components/FormSection";
import Heading from "../../components/Heading";
import { ActionButton } from "../../components/Forms/ActionButton";
import ImageInput from "../../components/Forms/ImageInput";
import MediaUpload from "../../components/Forms/MediaUpload";
import { createNgo, updateNgo } from "../../api/users";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useForm } from 'react-hook-form';
import ActiveStatus from '../../components/Common/ActiveStatus';
import { useLocation, useNavigate } from "react-router-dom";
import { useGetNgoInfo, useSavePartnerAndSendCredentials } from "../../queries/user";
import NewDropdown from "../../components/Forms/NewDropdown";
import Select from 'react-select';
import FileHandler from "../../components/Forms/FileHandler";
import countryStatesMapping from "../../data/countryStatesMapping";

export const NgoForm = () => {

    const { state } = useLocation();
    const ngoId = state?._id;

    const navigate = useNavigate();

    const { data, isLoading } = useGetNgoInfo(ngoId);

    const { mutateAsync: saveAndSendCredentials, isPending: isSendingCredentials } = useSavePartnerAndSendCredentials();

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset,
        watch,
        setValue,
        getValues,
        setError,
        clearErrors,
    } = useForm({
        defaultValues: {
            // NGO Information
            ngoName: '',
            email: '',
            dateOfEstablishment: '',
            phone: '',
            branchAddress: '',
            country: '',
            state: '',
            city: '',
            active: false,
            headquarterAddress: '',
            websiteUrl: '',
            registration80G: '',
            registration12A: '',
            fcraStatus: '',
            taxExemptionCertificateDetails: '',
            // Social Media
            linkedIn: '',
            instagram: '',
            facebook: '',
            twitter: '',
            youtube: '',
            website: '',
            // Point of Contact
            pocName: '',
            pocDesignation: '',
            pocPhone: '',
            pocMobile: '',
            pocEmail: '',
            // Account Details
            username: '',
            // password: '',
            displayName: '',
            emailRecipients: '',
            // Organizational Details
            visionAndObjective: '',
            keyFocusArea: '',
            keyProgram: '',
            fundingSources: '',
            activitiesToPromoteThroughThePartnership: '',
            geographicScopeOfOperations: '',
            targetBeneficiaries: '',
            // Partnership Details
            typesOfEngagement: '',
            partnershipStartDate: '',
            partnershipGoals: '',
            // Tree Plantation Drives
            treePlantationPreferredLocation: '',
            treePlantationFrequency: '',
            treePlantationFewPastDriveDetails: '',
            treePlantationTotalNumberOfDrives: '',
            treePlantationTotalNumberOfPlants: '',
            typeOfTreesPlanted: '',
            // Food Distribution Drives
            foodDistributionPreferredLocation: '',
            foodDistributionFrequency: '',
            foodDistributionFewPastDriveDetails: '',
            foodDistributionTotalNumberOfDrives: '',
            foodDistributionTotalNumberOfPlants: '',
            // Events
            typeOfEvents: '',
            eventsFrequency: '',
            eventsPreferredLocation: '',
            volunteerNeeds: '',
            detailsOfEvents: '',
            // Compliance & Agreements
            complianceAndAgreements: {
                signedPartnershipAgreementOrTermsAndConditionsAcceptance: '',
                dataPrivacyComplianceAcknowledgment: '',
                agreements: []
            },
            newComplianceDocuments: [],
            // Impact & Reporting
            metricsOrDataPointsTheyPlanToTrack: '',
            reportingFrequency: '',
            reportingGoals: '',
            remarksOrNotes: '',
        }
    });

    // NGO Information fields configuration
    const formData = [
        { label: 'NGO Name', placeholder: 'Enter NGO Name', name: 'ngoName', required: true },
        { label: 'Email', placeholder: 'Enter Email', name: 'email', required: true },
        { label: 'Date of Establishment', placeholder: 'Enter Date of Establishment', name: 'dateOfEstablishment', type: 'date' },
        { label: 'Phone Number', placeholder: 'Enter Phone Number', name: 'phone' },
        { label: 'Branch Address', placeholder: 'Enter Branch Address', name: 'branchAddress' },
        { label: 'Country', placeholder: 'Select Country', name: 'country', required: false },
        { label: 'State', placeholder: 'Select State', name: 'state', type: 'select', required: false },
        { label: 'City', placeholder: 'Enter City', name: 'city', required: false },
        { label: 'Headquarter Address', placeholder: 'Enter Headquarter Address', name: 'headquarterAddress' },
        { label: 'Website URL', placeholder: 'Enter Website URL', name: 'websiteUrl', required: false },
        { label: '80G Registration', placeholder: 'Enter 80G Registration', name: 'registration80G' },
        { label: '12A Registration', placeholder: 'Enter 12A Registration', name: 'registration12A' },
        { label: 'FCRA Status', placeholder: 'Enter FCRA Status', name: 'fcraStatus' },
        { label: 'Tax Exemption Certificate details', placeholder: 'Enter Tax Exemption Certificate details', name: 'taxExemptionCertificateDetails' },
    ];

    const socialFields = [
        { label: 'LinkedIn Account Link', placeholder: 'Enter LinkedIn Account Link', name: 'linkedIn', value: '' },
        { label: 'Instagram Account Link', placeholder: 'Enter Instagram Account Link', name: 'instagram', value: '' },
        { label: 'Facebook Account Link', placeholder: 'Enter Facebook Account Link', name: 'facebook', value: '' },
        { label: 'Twitter Account Link', placeholder: 'Enter Twitter Account Link', name: 'twitter', value: '' },
        { label: 'YouTube Account Link', placeholder: 'Enter YouTube Account Link', name: 'youtube', value: '' },
        // Removed duplicate website link from social fields (websiteUrl exists in basic details)
    ];

    // Account Details fields configuration
    const accountFields = [
        { label: 'Username', placeholder: 'Enter Username', name: 'username', required: false },
        // { label: 'Password', placeholder: 'Enter Password', name: 'password', required: false },
        { label: 'Display Name', placeholder: 'Enter Display Name', name: 'displayName', required: false },
        { label: 'Send Email To (Separate by commas)', placeholder: 'Enter Email Addresses', name: 'emailRecipients', required: false },
    ];

    const pocFields = [
        { label: 'Name of the primary contact person', placeholder: 'Enter Name of the primary contact person', name: 'pocName', required: false },
        { label: 'Designation/Role', placeholder: 'Enter Designation/Role', name: 'pocDesignation', value: '' },
        { label: 'Phone Number', placeholder: 'Enter Phone Number', name: 'pocPhone', value: '' },
        { label: 'Mobile Number', placeholder: 'Enter Mobile Number', name: 'pocMobile', value: '' },
        { label: 'Email Address', placeholder: 'Enter Email Address', name: 'pocEmail', required: false },
    ];

    const organizationalFields = [
        { label: "Description of the NGO's mission, vision, and objectives", placeholder: "Enter Description of the NGO's mission, vision, and objectives", name: 'visionAndObjective', type: 'textarea' },
        { label: 'Key Focus Areas', placeholder: 'Enter Key Focus Areas (e.g., environmental conservation, education, healthcare)', name: 'keyFocusArea' },
        { label: 'Key Programs/Projects', placeholder: 'Enter Key Programs/Projects', name: 'keyProgram' },
        { label: 'Funding Sources', placeholder: 'Select Funding Sources', name: 'fundingSources' },
        { label: 'Specific activities or project to promote through the partnership', placeholder: 'Enter Specific activities or projects to promote through the partnership', name: 'activitiesToPromoteThroughThePartnership' },
        { label: 'Geographic scope of operations', placeholder: 'Enter Geographic scope of operations (local, regional, national, or international)', name: 'geographicScopeOfOperations' },
        { label: 'Target beneficiaries', placeholder: 'Enter Target beneficiaries (e.g., communities, endangered species, youth)', name: 'targetBeneficiaries' },
    ];

    const partnershipFields = [
        {
            label: 'Types of Engagement', placeholder: 'Enter Types of Engagement (select one or both)', name: 'typesOfEngagement', type: 'select', data: [
                { value: 'Tree Planting', label: 'Tree Planting' },
                { value: 'Food Distribution', label: 'Food Distribution' },
                { value: 'Event Promotion', label: 'Event Promotion' },
            ]
        },
        { label: 'Partnership Start Date', placeholder: 'Choose Partnership Start Date', name: 'partnershipStartDate', type: 'date' },
        { label: 'Partnership Goals', placeholder: 'Write Partnership Goals (specific activities, projects to promote through partnership)', name: 'partnershipGoals', type: 'textarea' },
    ];

    const treePlantationFields = [
        { label: 'Preferred Location', placeholder: 'Select Preferred Location', name: 'treePlantationPreferredLocation', type: 'text' },
        {
            label: 'General Frequency', placeholder: 'Select Frequency', name: 'treePlantationFrequency', type: 'select', data: [
                { value: 'Weekly', placeholder: 'Weekly' },
                { value: 'Monthly', placeholder: 'Monthly' },
                { value: 'Quarterly', placeholder: 'Quarterly' },
                { value: 'Annually', placeholder: 'Annually' },
                { value: 'Ad-hoc', placeholder: 'Ad-hoc' },
            ]
        },
        { label: 'Past few drive details', placeholder: 'Enter Few past drive details', name: 'treePlantationFewPastDriveDetails', type: 'textarea' },
        { label: 'Total Number Of Drives', placeholder: 'Enter Total number of drives (till date)', name: 'treePlantationTotalNumberOfDrives', type: 'number' },
        { label: 'Total Number Of Plants', placeholder: 'Enter Total number of plants (till date)', name: 'treePlantationTotalNumberOfPlants', type: 'number' },
        { label: 'Type of trees planted', placeholder: 'Enter Type of trees planted', name: 'typeOfTreesPlanted' },
    ];

    const foodDistributionFields = [
        { label: 'Preferred Location', placeholder: 'Select Preferred Location', name: 'foodDistributionPreferredLocation', type: 'text' },
        {
            label: 'General Frequency', placeholder: 'Select Frequency', name: 'foodDistributionFrequency', type: 'select', data: [
                { value: 'Weekly', placeholder: 'Weekly' },
                { value: 'Monthly', placeholder: 'Monthly' },
                { value: 'Quarterly', placeholder: 'Quarterly' },
                { value: 'Annually', placeholder: 'Annually' },
                { value: 'Ad-hoc', placeholder: 'Ad-hoc' },
            ]
        },
        { label: 'Few Past Drive Details', placeholder: 'Enter Few Past Drive Details', name: 'foodDistributionFewPastDriveDetails', type: 'textarea' },
        { label: 'Total Amount Distributed (in KGs)', placeholder: 'Enter Total Amount Distributed (Till date)', name: 'foodDistributionTotalNumberOfDrives', type: 'number' },
        { label: 'Total Beneficiaries', placeholder: 'Enter Total Beneficiaries (Till date)', name: 'foodDistributionTotalNumberOfPlants', type: 'number' },
    ];

    const eventFields = [
        {
            label: 'Type of events', placeholder: 'Enter Type of events', name: 'typeOfEvents', type: 'select', data: [
                { value: 'Clean-Up Drive', placeholder: 'Clean-Up Drive' },
                { value: 'Awareness Campaign', placeholder: 'Awareness Campaign' },
                { value: 'Health Camps', placeholder: 'Health Camps' },
                { value: 'Educational Workshop', placeholder: 'Educational Workshop' },
                { value: 'Community Engagement', placeholder: 'Community Engagement' },
                { value: 'Fundraising Events', placeholder: 'Fundraising Events' },
            ]
        },
        {
            label: 'General Frequency', placeholder: 'Select Frequency', name: 'eventsFrequency', type: 'select', data: [
                { value: 'Weekly', placeholder: 'Weekly' },
                { value: 'Monthly', placeholder: 'Monthly' },
                { value: 'Quarterly', placeholder: 'Quarterly' },
                { value: 'Annually', placeholder: 'Annually' },
                { value: 'Ad-hoc', placeholder: 'Ad-hoc' },
            ]
        },
        { label: 'Preferred Location', placeholder: 'Select Preferred Location', name: 'eventsPreferredLocation', type: 'text' },
        { label: 'Volunteer Needs', placeholder: 'Enter Volunteer needs', name: 'volunteerNeeds' },
        { label: 'Past Few Event Details Of Events', placeholder: 'Write About Past Few Details Of Events (type of events (e.g beach clean up, vaccination camp etc), preferred location, Volunteer needs)', name: 'detailsOfEvents' },
    ];

    const impactFields = [
        {
            label: 'Metrics or data points they plan to track', label: 'Select Metrics or data points they plan to track (e.g., number of trees planted, number of volunteers recruited thru the app etc)', name: 'metricsOrDataPointsTheyPlanToTrack', type: 'select', data: [
                { value: 'Number of Trees Planted', label: 'Number of Trees Planted' },
                { value: 'Number of points redeemed', label: 'Number of points redeemed' },
                { value: 'Number of users engaged', label: 'Number of users engaged' },
                { value: 'Number of Meals Distributed', label: 'Number of Meals Distributed' },
                { value: 'Number of Volunteers Engaged', label: 'Number of Volunteers Engaged' },
            ]
        },
        { label: 'Reporting frequency', placeholder: 'Reporting frequency (e.g., monthly, quarterly updates)', name: 'reportingFrequency', type: 'select', data: [
            { value: 'Weekly', placeholder: 'Weekly' },
            { value: 'Monthly', placeholder: 'Monthly' },
            { value: 'Quarterly', placeholder: 'Quarterly' },
        ] },
        { label: 'Reporting Goals', placeholder: 'Reporting Goals', name: 'reportingGoals' },
        { label: 'Remarks/Notes', placeholder: 'Enter Remarks/Notes', name: 'remarksOrNotes' },
    ];

    const [image, setImage] = React.useState(null);
    const [active, setActive] = React.useState(false);

    const restructureFormData = (formValues, ngoId) => {
        const processedData = {
            ...formValues,
            // Add id if updating
            ...(ngoId && { id: ngoId }),
            // Remove account detail fields from top level
            username: undefined,
            // password: undefined,
            displayName: undefined,
            emailRecipients: undefined,
            // Convert country object to string if needed
            country: typeof formValues.country === 'object' && formValues.country?.value
                ? formValues.country.value
                : formValues.country
        };

        // Structure social links properly for the schema
        processedData.socialLinks = {
            linkedIn: formValues.linkedIn || '',
            instagram: formValues.instagram || '',
            facebook: formValues.facebook || '',
            twitter: formValues.twitter || '',
            youtube: formValues.youtube || '',
            website: formValues.website || '',
        };

        // Remove top-level social link fields
        delete processedData.linkedIn;
        delete processedData.instagram;
        delete processedData.facebook;
        delete processedData.twitter;
        delete processedData.youtube;
        delete processedData.website;

        // Structure point of contact properly for the schema
        processedData.pointOfContact = {
            pocName: formValues.pocName || '',
            pocDesignation: formValues.pocDesignation || '',
            pocPhone: formValues.pocPhone || '',
            pocMobile: formValues.pocMobile || '',
            pocEmail: formValues.pocEmail || '',
        };

        // Remove top-level POC fields
        delete processedData.pocName;
        delete processedData.pocDesignation;
        delete processedData.pocPhone;
        delete processedData.pocMobile;
        delete processedData.pocEmail;

        // Force userType to 'ngo'
        processedData.userType = 'ngo';

        // Normalize compliance documents for doc service (include both file & content keys)
        if (Array.isArray(processedData.newComplianceDocuments) && processedData.newComplianceDocuments.length > 0) {
            processedData.newComplianceDocuments = processedData.newComplianceDocuments.map(doc => ({
                ...doc,
                file: doc.base64 || doc.file || doc.content || '',
                content: doc.base64 || doc.file || doc.content || ''
            }));
        }

        // Structure organizational details properly for the schema
        processedData.organizationalDetails = {
            visionAndObjective: formValues.visionAndObjective || '',
            keyFocusArea: formValues.keyFocusArea || '',
            keyProgram: formValues.keyProgram || '',
            keyProjects: formValues.keyProjects || '',
            fundingSources: formValues.fundingSources || '',
            activitiesToPromoteThroughThePartnership: formValues.activitiesToPromoteThroughThePartnership || '',
            geographicScopeOfOperations: formValues.geographicScopeOfOperations || '',
            targetBeneficiaries: formValues.targetBeneficiaries || '',
        };

        // Remove top-level organizational detail fields
        delete processedData.visionAndObjective;
        delete processedData.keyFocusArea;
        delete processedData.keyProgram;
        delete processedData.keyProjects;
        delete processedData.fundingSources;
        delete processedData.activitiesToPromoteThroughThePartnership;
        delete processedData.geographicScopeOfOperations;
        delete processedData.targetBeneficiaries;

        // Structure account details properly for the schema
        processedData.accountDetails = {
            id: ngoId,
            ...processedData.accountDetails,
            username: formValues.username || '',
            displayName: formValues.displayName || '',
            emails: formValues.emailRecipients
                ? formValues.emailRecipients.split(',').map(email => email.trim()).filter(email => email.length > 0)
                : []
        };

        // Structure partnership details properly for the schema
        processedData.partnershipDetails = {
            typesOfEngagement: formValues.typesOfEngagement || [],
            partnershipStartDate: formValues.partnershipStartDate || '',
            partnershipGoals: formValues.partnershipGoals || '',
        };

        // Remove top-level partnership detail fields
        delete processedData.typesOfEngagement;
        delete processedData.partnershipStartDate;
        delete processedData.partnershipGoals;

        // Structure tree plantation drives properly for the schema
        processedData.treePlantationDrives = {
            treePlantationPreferredLocation: formValues.treePlantationPreferredLocation || '',
            treePlantationFrequency: formValues.treePlantationFrequency || '',
            treePlantationFewPastDriveDetails: formValues.treePlantationFewPastDriveDetails || '',
            treePlantationTotalNumberOfDrives: formValues.treePlantationTotalNumberOfDrives || '',
            treePlantationTotalNumberOfPlants: formValues.treePlantationTotalNumberOfPlants || '',
            typeOfTreesPlanted: formValues.typeOfTreesPlanted || '',
        };

        // Remove top-level tree plantation fields
        delete processedData.treePlantationPreferredLocation;
        delete processedData.treePlantationFrequency;
        delete processedData.treePlantationFewPastDriveDetails;
        delete processedData.treePlantationTotalNumberOfDrives;
        delete processedData.treePlantationTotalNumberOfPlants;
        delete processedData.typeOfTreesPlanted;

        // Structure food distribution drives properly for the schema
        processedData.foodDistributionDrives = {
            foodDistributionPreferredLocation: formValues.foodDistributionPreferredLocation || '',
            foodDistributionFrequency: formValues.foodDistributionFrequency || '',
            foodDistributionFewPastDriveDetails: formValues.foodDistributionFewPastDriveDetails || '',
            foodDistributionTotalNumberOfDrives: formValues.foodDistributionTotalNumberOfDrives || '',
            foodDistributionTotalNumberOfPlants: formValues.foodDistributionTotalNumberOfPlants || '',
        };

        // Remove top-level food distribution fields
        delete processedData.foodDistributionPreferredLocation;
        delete processedData.foodDistributionFrequency;
        delete processedData.foodDistributionFewPastDriveDetails;
        delete processedData.foodDistributionTotalNumberOfDrives;
        delete processedData.foodDistributionTotalNumberOfPlants;

        // Structure events properly for the schema
        processedData.events = {
            typeOfEvents: formValues.typeOfEvents || '',
            eventsFrequency: formValues.eventsFrequency || '',
            eventsPreferredLocation: formValues.eventsPreferredLocation || '',
            volunteerNeeds: formValues.volunteerNeeds || '',
            detailsOfEvents: formValues.detailsOfEvents || '',
        };

        // Remove top-level events fields
        delete processedData.typeOfEvents;
        delete processedData.eventsFrequency;
        delete processedData.eventsPreferredLocation;
        delete processedData.volunteerNeeds;
        delete processedData.detailsOfEvents;

        // Structure impact and reporting properly for the schema
        processedData.impactAndReporting = {
            metricsOrDataPointsTheyPlanToTrack: formValues.metricsOrDataPointsTheyPlanToTrack || [],
            reportingFrequency: formValues.reportingFrequency || '',
            reportingGoals: formValues.reportingGoals || '',
            remarksOrNotes: formValues.remarksOrNotes || '',
        };

        // Remove top-level impact and reporting fields
        delete processedData.metricsOrDataPointsTheyPlanToTrack;
        delete processedData.reportingFrequency;
        delete processedData.reportingGoals;
        delete processedData.remarksOrNotes;


        //
        return processedData;
    };

    const onSubmit = async (data) => {
        // Basic validation for required fields
        const validationErrors = {};

        // Check NGO Name (required field)
        if (!data.ngoName || data.ngoName.trim() === '') {
            validationErrors.ngoName = 'NGO Name is required';
        }

        // Check Email (required field in schema)
        if (!data.email || data.email.trim() === '') {
            validationErrors.email = 'NGO Email is required';
        } else {
            // Validate email format
            const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
            if (!emailRegex.test(data.email.trim())) {
                validationErrors.email = 'Invalid email format';
            }
        }

        // Check Phone (required field)
        if (!data.phone || data.phone.trim() === '') {
            validationErrors.phone = 'Phone Number is required';
        }

        // Check Date of Establishment (required field)
        if (!data.dateOfEstablishment || data.dateOfEstablishment.trim() === '') {
            validationErrors.dateOfEstablishment = 'Date of Establishment is required';
        }

        // If there are validation errors, set them and return
        if (Object.keys(validationErrors).length > 0) {
            // Set errors for each field
            Object.keys(validationErrors).forEach(field => {
                setError(field, {
                    type: 'manual',
                    message: validationErrors[field]
                });
            });

            // Show a toast message with specific error details
            const errorMessages = Object.values(validationErrors).join(', ');
            toast.error(`Please fix the following errors: ${errorMessages}`, {
                duration: 5000,
                position: 'top-right',
            });

            // Scroll to the first section with an error
            const firstErrorField = Object.keys(validationErrors)[0];
            let sectionToScroll = null;

            if (['ngoName', 'email', 'phone', 'dateOfEstablishment'].includes(firstErrorField)) {
                sectionToScroll = document.querySelector('[title="NGO Information"]');
            }

            if (sectionToScroll) {
                sectionToScroll.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }

            return;
        }

        // Clear any existing errors
        clearErrors(['ngoName', 'email', 'phone', 'dateOfEstablishment']);

        const processedData = restructureFormData(data, ngoId);

        // Convert Select multi-value objects to array of primitive values expected by backend
        if (Array.isArray(processedData.partnershipDetails?.typesOfEngagement)) {
            processedData.partnershipDetails.typesOfEngagement = processedData.partnershipDetails.typesOfEngagement.map(item => typeof item === 'object' ? item.value : item);
        }
        if (Array.isArray(processedData.impactAndReporting?.metricsOrDataPointsTheyPlanToTrack)) {
            processedData.impactAndReporting.metricsOrDataPointsTheyPlanToTrack = processedData.impactAndReporting.metricsOrDataPointsTheyPlanToTrack.map(item => typeof item === 'object' ? item.value : item);
        }

        // Add the logo
        const finalData = {
            ...processedData,
            logo: image
        };

        try {
            // Debug logs to help debug document saving issues
            console.debug('Submitting NGO (onSubmit) - newComplianceDocuments keys:', finalData.newComplianceDocuments?.map(doc => Object.keys(doc)));
            if (ngoId) {
                await updateNgo(ngoId, finalData, image, toast);
            } else {
                await createNgo(finalData, image, toast);
            }
            setTimeout(() => {
                navigate('/user/list/ngos');
            }, 2000);
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.error('Failed to submit form');
        }
    };

    const handleSaveAndSendCred = async () => {
        // Get current form values
        const formValues = getValues();

        // Validate required fields for Save and Register
        const validationErrors = {};

        // Check NGO Name (required field)
        if (!formValues.ngoName || formValues.ngoName.trim() === '') {
            validationErrors.ngoName = 'NGO Name is required';
        }

        // Check Email (required field in schema)
        if (!formValues.email || formValues.email.trim() === '') {
            validationErrors.email = 'NGO Email is required';
        } else {
            // Validate email format
            const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
            if (!emailRegex.test(formValues.email.trim())) {
                validationErrors.email = 'Invalid email format';
            }
        }

        // Check username
        if (!formValues.username || formValues.username.trim() === '') {
            validationErrors.username = 'Username is required';
        } else if (formValues.username.length < 3) {
            validationErrors.username = 'Username must be at least 3 characters';
        }

        // Check display name
        if (!formValues.displayName || formValues.displayName.trim() === '') {
            validationErrors.displayName = 'Display Name is required';
        } else if (formValues.displayName.length < 2) {
            validationErrors.displayName = 'Display name must be at least 2 characters';
        }

        // Check email recipients
        if (!formValues.emailRecipients || formValues.emailRecipients.trim() === '') {
            validationErrors.emailRecipients = 'Email recipients are required';
        } else {
            // Validate email format
            const emails = formValues.emailRecipients.split(',').map(email => email.trim());
            const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
            const invalidEmails = emails.filter(email => email && !emailRegex.test(email));
            if (invalidEmails.length > 0) {
                validationErrors.emailRecipients = `Invalid email format: ${invalidEmails.join(', ')}`;
            }
        }

        // If there are validation errors, set them and return
        if (Object.keys(validationErrors).length > 0) {
            // Set errors for each field
            Object.keys(validationErrors).forEach(field => {
                setError(field, {
                    type: 'manual',
                    message: validationErrors[field]
                });
            });

            // Show a toast message with specific error details listing all errors
            const errorMessages = Object.values(validationErrors).join(', ');
            toast.error(`Please fix the following errors: ${errorMessages}`, {
                duration: 5000,
                position: 'top-right',
            });

            // Scroll to the first section with an error
            const firstErrorField = Object.keys(validationErrors)[0];
            let sectionToScroll = null;

            if (['ngoName', 'email'].includes(firstErrorField)) {
                sectionToScroll = document.querySelector('[title="NGO Information"]');
            } else if (['username', 'displayName', 'emailRecipients'].includes(firstErrorField)) {
                sectionToScroll = document.querySelector('[title="Account Details"]');
            }

            if (sectionToScroll) {
                sectionToScroll.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }

            return;
        }

        // Clear any existing errors
        clearErrors(['ngoName', 'email', 'username', 'displayName', 'emailRecipients']);

        const processedData = restructureFormData(formValues, ngoId);

        if (Array.isArray(processedData.partnershipDetails?.typesOfEngagement)) {
            processedData.partnershipDetails.typesOfEngagement = processedData.partnershipDetails.typesOfEngagement.map(item => typeof item === 'object' ? item.value : item);
        }
        if (Array.isArray(processedData.impactAndReporting?.metricsOrDataPointsTheyPlanToTrack)) {
            processedData.impactAndReporting.metricsOrDataPointsTheyPlanToTrack = processedData.impactAndReporting.metricsOrDataPointsTheyPlanToTrack.map(item => typeof item === 'object' ? item.value : item);
        }

        // Add the logo
        const finalData = {
            ...processedData,
            logo: image
        };

        console.log('Processed data for save and send credentials:', finalData);

        // Show loading toast
        const loadingToastId = toast.loading('Saving NGO data and sending credentials...');

        // If validation passes, proceed with save and send credentials
        try {
            console.debug('Save & Register - finalData newComplianceDocuments keys:', finalData.newComplianceDocuments?.map(doc => Object.keys(doc)));

            let result;
            // Both create and update modes use the same approach
            finalData.sendCredentials = true;

            if (ngoId) {
                // Update mode - use the regular update endpoint with sendCredentials flag
                await updateNgo(ngoId, finalData, image, toast);

                // Dismiss loading toast
                toast.dismiss(loadingToastId);

                // Success - updateNgo already shows toast, just add credentials message and navigate
                toast.success('Credentials sent successfully!', {
                    duration: 3000,
                    position: 'top-right',
                });
                setTimeout(() => {
                    navigate('/user/list/ngos');
                }, 2000);
            } else {
                // Create mode - use the regular create endpoint with sendCredentials flag
                await createNgo(finalData, image, toast);

                // Dismiss loading toast
                toast.dismiss(loadingToastId);

                // Success - createNgo already shows toast, just add credentials message and navigate
                toast.success('Credentials sent successfully!', {
                    duration: 3000,
                    position: 'top-right',
                });
                setTimeout(() => {
                    navigate('/user/list/ngos');
                }, 2000);
            }
        } catch (error) {
            // Dismiss loading toast
            toast.dismiss(loadingToastId);
            console.error('Error saving and sending credentials:', error);
            toast.error('Failed to save data and send credentials. Please try again.');
        }
    }

    React.useEffect(() => {
        if (data) {
            // Handle both data structures: direct NGO object or wrapped in 'ngo' property
            const ngoData = data.ngo || data;
            
            // Populate main NGO fields
            setValue('ngoName', ngoData.ngoName || '');
            setValue('email', ngoData.email || '');
            setValue('dateOfEstablishment', ngoData.dateOfEstablishment ? ngoData.dateOfEstablishment.split('T')[0] : '');
            setValue('phone', ngoData.phone || '');
            setValue('branchAddress', ngoData.branchAddress || '');
            setValue('country', ngoData.country || '');
            setValue('state', ngoData.state || '');
            setValue('city', ngoData.city || '');
            setValue('active', ngoData.active !== undefined ? ngoData.active : false);
            setActive(ngoData.active !== undefined ? ngoData.active : false);
            setValue('headquarterAddress', ngoData.headquarterAddress || '');
            setValue('websiteUrl', ngoData.websiteUrl || '');
            setValue('registration80G', ngoData.registration80G || '');
            setValue('registration12A', ngoData.registration12A || '');
            setValue('fcraStatus', ngoData.fcraStatus || '');
            setValue('taxExemptionCertificateDetails', ngoData.taxExemptionCertificateDetails || '');

            // Populate social links
            if (ngoData.socialLinks) {
                setValue('linkedIn', ngoData.socialLinks.linkedIn || '');
                setValue('instagram', ngoData.socialLinks.instagram || '');
                setValue('facebook', ngoData.socialLinks.facebook || '');
                setValue('twitter', ngoData.socialLinks.twitter || '');
                setValue('youtube', ngoData.socialLinks.youtube || '');
                setValue('website', ngoData.socialLinks.website || '');
            }

            // Populate point of contact
            if (ngoData.pointOfContact) {
                setValue('pocName', ngoData.pointOfContact.pocName || '');
                setValue('pocDesignation', ngoData.pointOfContact.pocDesignation || '');
                setValue('pocPhone', ngoData.pointOfContact.pocPhone || '');
                setValue('pocMobile', ngoData.pointOfContact.pocMobile || '');
                setValue('pocEmail', ngoData.pointOfContact.pocEmail || '');
            }

            // Populate account details
            if (ngoData.accountDetails) {
                setValue('username', ngoData.accountDetails.username || '');
                setValue('displayName', ngoData.accountDetails.displayName || '');
                // Convert emails array back to comma-separated string
                if (ngoData.accountDetails.emails && Array.isArray(ngoData.accountDetails.emails)) {
                    setValue('emailRecipients', ngoData.accountDetails.emails.join(', '));
                }
                // Note: Don't populate password for security reasons
            }

            // Populate organizational details
            if (ngoData.organizationalDetails) {
                setValue('visionAndObjective', ngoData.organizationalDetails.visionAndObjective || '');
                setValue('keyFocusArea', ngoData.organizationalDetails.keyFocusArea || '');
                setValue('keyProgram', ngoData.organizationalDetails.keyProgram || '');
                setValue('keyProjects', ngoData.organizationalDetails.keyProjects || '');
                setValue('fundingSources', ngoData.organizationalDetails.fundingSources || '');
                setValue('activitiesToPromoteThroughThePartnership', ngoData.organizationalDetails.activitiesToPromoteThroughThePartnership || '');
                setValue('geographicScopeOfOperations', ngoData.organizationalDetails.geographicScopeOfOperations || '');
                setValue('targetBeneficiaries', ngoData.organizationalDetails.targetBeneficiaries || '');
            }

            // Populate partnership details
            if (ngoData.partnershipDetails) {
                const typesOfEngagement = ngoData.partnershipDetails.typesOfEngagement || [];
                const typeOptions = typesOfEngagement.map(val => {
                    if (typeof val === 'string') {
                        return { value: val, label: val };
                    } else if (val && typeof val === 'object' && val.value) {
                        return { value: val.value, label: val.label || val.value };
                    }
                    return { value: val, label: val };
                });
                setValue('typesOfEngagement', typeOptions);
                setValue('partnershipStartDate', ngoData.partnershipDetails.partnershipStartDate ? ngoData.partnershipDetails.partnershipStartDate.split('T')[0] : '');
                setValue('partnershipGoals', ngoData.partnershipDetails.partnershipGoals || '');
            }

            // Populate tree plantation drives
            if (ngoData.treePlantationDrives) {
                setValue('treePlantationPreferredLocation', ngoData.treePlantationDrives.treePlantationPreferredLocation || '');
                setValue('treePlantationFrequency', ngoData.treePlantationDrives.treePlantationFrequency || '');
                setValue('treePlantationFewPastDriveDetails', ngoData.treePlantationDrives.treePlantationFewPastDriveDetails || '');
                setValue('treePlantationTotalNumberOfDrives', ngoData.treePlantationDrives.treePlantationTotalNumberOfDrives || '');
                setValue('treePlantationTotalNumberOfPlants', ngoData.treePlantationDrives.treePlantationTotalNumberOfPlants || '');
                setValue('typeOfTreesPlanted', ngoData.treePlantationDrives.typeOfTreesPlanted || '');
            }

            // Populate food distribution drives
            if (ngoData.foodDistributionDrives) {
                setValue('foodDistributionPreferredLocation', ngoData.foodDistributionDrives.foodDistributionPreferredLocation || '');
                setValue('foodDistributionFrequency', ngoData.foodDistributionDrives.foodDistributionFrequency || '');
                setValue('foodDistributionFewPastDriveDetails', ngoData.foodDistributionDrives.foodDistributionFewPastDriveDetails || '');
                setValue('foodDistributionTotalNumberOfDrives', ngoData.foodDistributionDrives.foodDistributionTotalNumberOfDrives || '');
                setValue('foodDistributionTotalNumberOfPlants', ngoData.foodDistributionDrives.foodDistributionTotalNumberOfPlants || '');
            }

            // Populate events
            if (ngoData.events) {
                setValue('typeOfEvents', ngoData.events.typeOfEvents || '');
                setValue('eventsFrequency', ngoData.events.eventsFrequency || '');
                setValue('eventsPreferredLocation', ngoData.events.eventsPreferredLocation || '');
                setValue('volunteerNeeds', ngoData.events.volunteerNeeds || '');
                setValue('detailsOfEvents', ngoData.events.detailsOfEvents || '');
            }

            // Populate compliance and agreements
            if (ngoData.complianceAndAgreements) {
                setValue('complianceAndAgreements.signedPartnershipAgreementOrTermsAndConditionsAcceptance', ngoData.complianceAndAgreements.signedPartnershipAgreementOrTermsAndConditionsAcceptance || '');
                setValue('complianceAndAgreements.dataPrivacyComplianceAcknowledgment', ngoData.complianceAndAgreements.dataPrivacyComplianceAcknowledgment || '');
                setValue('complianceAndAgreements.agreements', ngoData.complianceAndAgreements.agreements || []);
            }

            // Populate impact and reporting
            if (ngoData.impactAndReporting) {
                const metrics = ngoData.impactAndReporting.metricsOrDataPointsTheyPlanToTrack || [];
                const metricsOptions = metrics.map(v => {
                    if (typeof v === 'string') {
                        return { value: v, label: v };
                    } else if (v && typeof v === 'object' && v.value) {
                        return { value: v.value, label: v.label || v.value };
                    }
                    return { value: v, label: v };
                });
                setValue('metricsOrDataPointsTheyPlanToTrack', metricsOptions);
                setValue('reportingFrequency', ngoData.impactAndReporting.reportingFrequency || '');
                setValue('reportingGoals', ngoData.impactAndReporting.reportingGoals || '');
                setValue('remarksOrNotes', ngoData.impactAndReporting.remarksOrNotes || '');
            }

            // Set logo image
            if (ngoData.logo) {
                setTimeout(() => {
                    setImage(ngoData.logo);
                }, 200);
            }
        }
    }, [data, setValue]);

    const watchedCountry = watch('country');
    const watchedState = watch('state');
    const watchedCity = watch('city');
    const watchedTypesOfEngagement = watch('typesOfEngagement');
    const watchedMetrics = watch('metricsOrDataPointsTheyPlanToTrack');

    const countryData = [
        { value: 'Afghanistan', label: 'Afghanistan' },
        { value: 'Albania', label: 'Albania' },
        { value: 'Algeria', label: 'Algeria' },
        { value: 'Andorra', label: 'Andorra' },
        { value: 'Angola', label: 'Angola' },
        { value: 'Argentina', label: 'Argentina' },
        { value: 'Armenia', label: 'Armenia' },
        { value: 'Australia', label: 'Australia' },
        { value: 'Austria', label: 'Austria' },
        { value: 'Azerbaijan', label: 'Azerbaijan' },
        { value: 'Bahamas', label: 'Bahamas' },
        { value: 'Bahrain', label: 'Bahrain' },
        { value: 'Bangladesh', label: 'Bangladesh' },
        { value: 'Barbados', label: 'Barbados' },
        { value: 'Belarus', label: 'Belarus' },
        { value: 'Belgium', label: 'Belgium' },
        { value: 'Belize', label: 'Belize' },
        { value: 'Benin', label: 'Benin' },
        { value: 'Bhutan', label: 'Bhutan' },
        { value: 'Bolivia', label: 'Bolivia' },
        { value: 'Bosnia and Herzegovina', label: 'Bosnia and Herzegovina' },
        { value: 'Botswana', label: 'Botswana' },
        { value: 'Brazil', label: 'Brazil' },
        { value: 'Brunei', label: 'Brunei' },
        { value: 'Bulgaria', label: 'Bulgaria' },
        { value: 'Burkina Faso', label: 'Burkina Faso' },
        { value: 'Burundi', label: 'Burundi' },
        { value: 'Cambodia', label: 'Cambodia' },
        { value: 'Cameroon', label: 'Cameroon' },
        { value: 'Canada', label: 'Canada' },
        { value: 'Cape Verde', label: 'Cape Verde' },
        { value: 'Central African Republic', label: 'Central African Republic' },
        { value: 'Chad', label: 'Chad' },
        { value: 'Chile', label: 'Chile' },
        { value: 'China', label: 'China' },
        { value: 'Colombia', label: 'Colombia' },
        { value: 'Comoros', label: 'Comoros' },
        { value: 'Congo', label: 'Congo' },
        { value: 'Costa Rica', label: 'Costa Rica' },
        { value: 'Croatia', label: 'Croatia' },
        { value: 'Cuba', label: 'Cuba' },
        { value: 'Cyprus', label: 'Cyprus' },
        { value: 'Czech Republic', label: 'Czech Republic' },
        { value: 'Denmark', label: 'Denmark' },
        { value: 'Djibouti', label: 'Djibouti' },
        { value: 'Dominica', label: 'Dominica' },
        { value: 'Dominican Republic', label: 'Dominican Republic' },
        { value: 'Ecuador', label: 'Ecuador' },
        { value: 'Egypt', label: 'Egypt' },
        { value: 'El Salvador', label: 'El Salvador' },
        { value: 'Equatorial Guinea', label: 'Equatorial Guinea' },
        { value: 'Eritrea', label: 'Eritrea' },
        { value: 'Estonia', label: 'Estonia' },
        { value: 'Ethiopia', label: 'Ethiopia' },
        { value: 'Fiji', label: 'Fiji' },
        { value: 'Finland', label: 'Finland' },
        { value: 'France', label: 'France' },
        { value: 'Gabon', label: 'Gabon' },
        { value: 'Gambia', label: 'Gambia' },
        { value: 'Georgia', label: 'Georgia' },
        { value: 'Germany', label: 'Germany' },
        { value: 'Ghana', label: 'Ghana' },
        { value: 'Greece', label: 'Greece' },
        { value: 'Grenada', label: 'Grenada' },
        { value: 'Guatemala', label: 'Guatemala' },
        { value: 'Guinea', label: 'Guinea' },
        { value: 'Guinea-Bissau', label: 'Guinea-Bissau' },
        { value: 'Guyana', label: 'Guyana' },
        { value: 'Haiti', label: 'Haiti' },
        { value: 'Honduras', label: 'Honduras' },
        { value: 'Hungary', label: 'Hungary' },
        { value: 'Iceland', label: 'Iceland' },
        { value: 'India', label: 'India' },
        { value: 'Indonesia', label: 'Indonesia' },
        { value: 'Iran', label: 'Iran' },
        { value: 'Iraq', label: 'Iraq' },
        { value: 'Ireland', label: 'Ireland' },
        { value: 'Israel', label: 'Israel' },
        { value: 'Italy', label: 'Italy' },
        { value: 'Jamaica', label: 'Jamaica' },
        { value: 'Japan', label: 'Japan' },
        { value: 'Jordan', label: 'Jordan' },
        { value: 'Kazakhstan', label: 'Kazakhstan' },
        { value: 'Kenya', label: 'Kenya' },
        { value: 'Kiribati', label: 'Kiribati' },
        { value: 'Kuwait', label: 'Kuwait' },
        { value: 'Kyrgyzstan', label: 'Kyrgyzstan' },
        { value: 'Laos', label: 'Laos' },
        { value: 'Latvia', label: 'Latvia' },
        { value: 'Lebanon', label: 'Lebanon' },
        { value: 'Lesotho', label: 'Lesotho' },
        { value: 'Liberia', label: 'Liberia' },
        { value: 'Libya', label: 'Libya' },
        { value: 'Liechtenstein', label: 'Liechtenstein' },
        { value: 'Lithuania', label: 'Lithuania' },
        { value: 'Luxembourg', label: 'Luxembourg' },
        { value: 'Madagascar', label: 'Madagascar' },
        { value: 'Malawi', label: 'Malawi' },
        { value: 'Malaysia', label: 'Malaysia' },
        { value: 'Maldives', label: 'Maldives' },
        { value: 'Mali', label: 'Mali' },
        { value: 'Malta', label: 'Malta' },
        { value: 'Marshall Islands', label: 'Marshall Islands' },
        { value: 'Mauritania', label: 'Mauritania' },
        { value: 'Mauritius', label: 'Mauritius' },
        { value: 'Mexico', label: 'Mexico' },
        { value: 'Micronesia', label: 'Micronesia' },
        { value: 'Moldova', label: 'Moldova' },
        { value: 'Monaco', label: 'Monaco' },
        { value: 'Mongolia', label: 'Mongolia' },
        { value: 'Montenegro', label: 'Montenegro' },
        { value: 'Morocco', label: 'Morocco' },
        { value: 'Mozambique', label: 'Mozambique' },
        { value: 'Myanmar', label: 'Myanmar' },
        { value: 'Namibia', label: 'Namibia' },
        { value: 'Nauru', label: 'Nauru' },
        { value: 'Nepal', label: 'Nepal' },
        { value: 'Netherlands', label: 'Netherlands' },
        { value: 'New Zealand', label: 'New Zealand' },
        { value: 'Nicaragua', label: 'Nicaragua' },
        { value: 'Niger', label: 'Niger' },
        { value: 'Nigeria', label: 'Nigeria' },
        { value: 'North Korea', label: 'North Korea' },
        { value: 'North Macedonia', label: 'North Macedonia' },
        { value: 'Norway', label: 'Norway' },
        { value: 'Oman', label: 'Oman' },
        { value: 'Pakistan', label: 'Pakistan' },
        { value: 'Palau', label: 'Palau' },
        { value: 'Panama', label: 'Panama' },
        { value: 'Papua New Guinea', label: 'Papua New Guinea' },
        { value: 'Paraguay', label: 'Paraguay' },
        { value: 'Peru', label: 'Peru' },
        { value: 'Philippines', label: 'Philippines' },
        { value: 'Poland', label: 'Poland' },
        { value: 'Portugal', label: 'Portugal' },
        { value: 'Qatar', label: 'Qatar' },
        { value: 'Romania', label: 'Romania' },
        { value: 'Russia', label: 'Russia' },
        { value: 'Rwanda', label: 'Rwanda' },
        { value: 'Saint Kitts and Nevis', label: 'Saint Kitts and Nevis' },
        { value: 'Saint Lucia', label: 'Saint Lucia' },
        { value: 'Saint Vincent and the Grenadines', label: 'Saint Vincent and the Grenadines' },
        { value: 'Samoa', label: 'Samoa' },
        { value: 'San Marino', label: 'San Marino' },
        { value: 'Saudi Arabia', label: 'Saudi Arabia' },
        { value: 'Senegal', label: 'Senegal' },
        { value: 'Serbia', label: 'Serbia' },
        { value: 'Seychelles', label: 'Seychelles' },
        { value: 'Sierra Leone', label: 'Sierra Leone' },
        { value: 'Singapore', label: 'Singapore' },
        { value: 'Slovakia', label: 'Slovakia' },
        { value: 'Slovenia', label: 'Slovenia' },
        { value: 'Solomon Islands', label: 'Solomon Islands' },
        { value: 'Somalia', label: 'Somalia' },
        { value: 'South Africa', label: 'South Africa' },
        { value: 'South Korea', label: 'South Korea' },
        { value: 'South Sudan', label: 'South Sudan' },
        { value: 'Spain', label: 'Spain' },
        { value: 'Sri Lanka', label: 'Sri Lanka' },
        { value: 'Sudan', label: 'Sudan' },
        { value: 'Suriname', label: 'Suriname' },
        { value: 'Sweden', label: 'Sweden' },
        { value: 'Switzerland', label: 'Switzerland' },
        { value: 'Syria', label: 'Syria' },
        { value: 'Taiwan', label: 'Taiwan' },
        { value: 'Tajikistan', label: 'Tajikistan' },
        { value: 'Tanzania', label: 'Tanzania' },
        { value: 'Thailand', label: 'Thailand' },
        { value: 'Togo', label: 'Togo' },
        { value: 'Tonga', label: 'Tonga' },
        { value: 'Trinidad and Tobago', label: 'Trinidad and Tobago' },
        { value: 'Tunisia', label: 'Tunisia' },
        { value: 'Turkey', label: 'Turkey' },
        { value: 'Turkmenistan', label: 'Turkmenistan' },
        { value: 'Tuvalu', label: 'Tuvalu' },
        { value: 'Uganda', label: 'Uganda' },
        { value: 'Ukraine', label: 'Ukraine' },
        { value: 'United Arab Emirates', label: 'United Arab Emirates' },
        { value: 'United Kingdom', label: 'United Kingdom' },
        { value: 'United States', label: 'United States' },
        { value: 'Uruguay', label: 'Uruguay' },
        { value: 'Uzbekistan', label: 'Uzbekistan' },
        { value: 'Vanuatu', label: 'Vanuatu' },
        { value: 'Vatican City', label: 'Vatican City' },
        { value: 'Venezuela', label: 'Venezuela' },
        { value: 'Vietnam', label: 'Vietnam' },
        { value: 'Yemen', label: 'Yemen' },
        { value: 'Zambia', label: 'Zambia' },
        { value: 'Zimbabwe', label: 'Zimbabwe' }
    ];

    // Use the shared country-states mapping
    const stateData = watchedCountry ? (countryStatesMapping[watchedCountry] || []) : [];

    React.useEffect(() => {
        if (data && data.logo) {
            setImage(data.logo);
        }
    }, [data]);

    if (isLoading) {
        return <div>Loading...</div>;
    }

    return (
        <form className="flex flex-col" onSubmit={handleSubmit(onSubmit)} noValidate>
            <div className="flex items-center justify-between mb-4">
                <Heading text={ngoId ? "Edit NGO" : "NGO Creation Form"} />
                <ActiveStatus
                    active={active}
                    setActive={(newVal) => {
                        setActive(newVal);
                        setValue('active', newVal);
                    }}
                    isCreateForm={true}
                    label="Status"
                    innerActiveText="Active"
                    innerInactiveText="Inactive"
                />
            </div>

            <FormSection title="Basic Details" defaultExpanded={true}>
                <div className="flex flex-wrap gap-6 items-start w-full max-md:max-w-full">
                    <div className="flex flex-col gap-3 grow shrink text-sm min-w-[240px] w-[844px] max-md:max-w-full">
                        <div className="flex gap-3 items-center w-full">
                            <div className="flex flex-col flex-grow w-full gap-1">
                                <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                    <span className="text-red text-xs inline">*</span> {formData[0].label}
                                </label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <input
                                        type="text"
                                        placeholder={formData[0].placeholder}
                                        {...register(formData[0].name, {
                                            required: `${formData[0].label} is required`
                                        })}
                                        className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[0].name] ? "border-red-500" : ""}`}
                                    />
                                </div>
                                {errors[formData[0].name] && <p className="text-red text-sm">{errors[formData[0].name].message}</p>}
                            </div>
                            <div className="flex flex-col flex-grow w-full gap-1">
                                <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                    <span className="text-red text-xs inline">*</span> {formData[1].label}
                                </label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <input
                                        type="text"
                                        placeholder={formData[1].placeholder}
                                        {...register(formData[1].name, {
                                            required: `${formData[1].label} is required`
                                        })}
                                        className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[1].name] ? "border-red-500" : ""}`}
                                    />
                                </div>
                                {errors[formData[1].name] && <p className="text-red text-sm">{errors[formData[1].name].message}</p>}
                            </div>
                        </div>
                        <div className="flex gap-3">
                            <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                                <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                    <span className="text-red text-xs inline">*</span> {formData[3].label}
                                </label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <input
                                        type="tel"
                                        placeholder={formData[3].placeholder}
                                        {...register(formData[3].name, {
                                            required: `${formData[3].label} is required`
                                        })}
                                        className={`flex-1 shrink self-stretch my-auto basis-1/2 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[3].name] ? "border-red-500" : ""}`}
                                    />
                                </div>
                                {errors[formData[3].name] && <p className="text-red text-sm">{errors[formData[3].name].message}</p>}
                            </div>
                            <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                                <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                    <span className="text-red text-xs inline">*</span> {formData[2].label}
                                </label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <input
                                        type="date"
                                        placeholder={formData[2].placeholder}
                                        {...register(formData[2].name, {
                                            required: `${formData[2].label} is required`
                                        })}
                                        className={`flex-1 shrink self-stretch my-auto basis-1/2 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[2].name] ? "border-red-500" : ""}`}
                                    />
                                </div>
                                {errors[formData[2].name] && <p className="text-red text-sm">{errors[formData[2].name].message}</p>}
                            </div>
                        </div>
                        <div className="flex flex-col shrink-0 basis-0 w-full gap-1">
                            <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                {formData[4].label}
                            </label>
                            <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <textarea
                                    type="text"
                                    placeholder={formData[4].placeholder}
                                    {...register(formData[4].name)}
                                    className={`flex-1 shrink self-stretch min-h-[100px] my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[4].name] ? "border-red-500" : ""}`}
                                />
                            </div>
                            {errors[formData[4].name] && <p className="text-red text-sm">{errors[formData[4].name].message}</p>}
                        </div>
                        <div className="flex gap-3">
                            <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                                <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                    {formData[5].label}
                                </label>
                                <NewDropdown
                                    placeholder={formData[5].placeholder}
                                    dataList={countryData}
                                    name={formData[5].name}
                                    register={register(formData[5].name)}
                                    onChange={(value) => {
                                        setValue(formData[5].name, value?.value || value);
                                        setValue('state', '');
                                    }}
                                    value={watchedCountry}
                                    className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[5].name] ? "border-red-500" : ""}`}
                                />
                            </div>
                            <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                                <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                    {formData[6].label}
                                </label>
                                {stateData && stateData.length > 0 ? (
                                    <NewDropdown
                                        placeholder={formData[6].placeholder}
                                        dataList={stateData}
                                        name={formData[6].name}
                                        register={register(formData[6].name)}
                                        onChange={(value) => setValue(formData[6].name, value?.value || value)}
                                        value={watchedState}
                                        className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[6].name] ? "border-red-500" : ""}`}
                                    />
                                ) : (
                                    <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                        <input
                                            type="text"
                                            placeholder={formData[6].placeholder}
                                            {...register(formData[6].name)}
                                            className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[6].name] ? "border-red-500" : ""}`}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                                <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                    {formData[7].label}
                                </label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <input
                                        type="text"
                                        placeholder={formData[7].placeholder}
                                        {...register(formData[7].name)}
                                        className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[7].name] ? "border-red-500" : ""}`}
                                    />
                                </div>
                                {errors[formData[7].name] && <p className="text-red text-sm">{errors[formData[7].name].message}</p>}
                            </div>
                        </div>
                        <div className="flex gap-3">
                            <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                                <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                    {formData[8].label}
                                </label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <input
                                        type="text"
                                        placeholder={formData[8].placeholder}
                                        {...register(formData[8].name)}
                                        className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[8].name] ? "border-red-500" : ""}`}
                                    />
                                </div>
                                {errors[formData[8].name] && <p className="text-red text-sm">{errors[formData[8].name].message}</p>}
                            </div>
                            <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                                <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                    {formData[9].label}
                                </label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <input
                                        type="text"
                                        placeholder={formData[9].placeholder}
                                        {...register(formData[9].name)}
                                        className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[9].name] ? "border-red-500" : ""}`}
                                    />
                                </div>
                                {errors[formData[9].name] && <p className="text-red text-sm">{errors[formData[9].name].message}</p>}
                            </div>
                            <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                                <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                    {formData[10].label}
                                </label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <input
                                        type="url"
                                        placeholder={formData[10].placeholder}
                                        {...register(formData[10].name)}
                                        className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[10].name] ? "border-red-500" : ""}`}
                                    />
                                </div>
                                {errors[formData[10].name] && <p className="text-red text-sm">{errors[formData[10].name].message}</p>}
                            </div>
                        </div>
                        <div className="flex gap-3">
                            <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                                <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                    {formData[11].label}
                                </label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <input
                                        type="text"
                                        placeholder={formData[11].placeholder}
                                        {...register(formData[11].name)}
                                        className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[11].name] ? "border-red-500" : ""}`}
                                    />
                                </div>
                                {errors[formData[11].name] && <p className="text-red text-sm">{errors[formData[11].name].message}</p>}
                            </div>
                            <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                                <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                    {formData[12].label}
                                </label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <input
                                        type="text"
                                        placeholder={formData[12].placeholder}
                                        {...register(formData[12].name)}
                                        className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[12].name] ? "border-red-500" : ""}`}
                                    />
                                </div>
                                {errors[formData[12].name] && <p className="text-red text-sm">{errors[formData[12].name].message}</p>}
                            </div>
                            <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                                <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                                    {formData[13].label}
                                </label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <input
                                        type="text"
                                        placeholder={formData[13].placeholder}
                                        {...register(formData[13].name)}
                                        className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[formData[13].name] ? "border-red-500" : ""}`}
                                    />
                                </div>
                                {errors[formData[13].name] && <p className="text-red text-sm">{errors[formData[13].name].message}</p>}
                            </div>
                        </div>
                    </div>
                    <div className="mb-8 -mt-2">
                        <MediaUpload
                            existingImage={image}
                            stateImage={image}
                            setImageUpload={setImage}
                            setStateImageUpload={setImage}
                            label="logo"
                            useFileObject={true}
                        />
                    </div>
                </div>
            </FormSection>

            <FormSection title="Social Media Details" defaultExpanded={false}>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {socialFields[0].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="url"
                                placeholder={socialFields[0].placeholder}
                                {...register(socialFields[0].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {socialFields[1].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="url"
                                placeholder={socialFields[1].placeholder}
                                {...register(socialFields[1].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div>
                    </div>
                </div>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {socialFields[2].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="url"
                                placeholder={socialFields[2].placeholder}
                                {...register(socialFields[2].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {socialFields[3].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="url"
                                placeholder={socialFields[3].placeholder}
                                {...register(socialFields[3].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div>
                    </div>
                </div>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {socialFields[4].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="url"
                                placeholder={socialFields[4].placeholder}
                                {...register(socialFields[4].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div>
                    </div>
                </div>
            </FormSection>

            <FormSection title="Point Of Contact" defaultExpanded={false}>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {pocFields[0].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={pocFields[0].placeholder}
                                {...register(pocFields[0].name)}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[pocFields[0].name] ? "border-red-500" : ""}`}
                            />
                        </div>
                        {errors[pocFields[0].name] && <p className="text-red text-sm">{errors[pocFields[0].name].message}</p>}
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {pocFields[1].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={pocFields[1].placeholder}
                                {...register(pocFields[1].name)}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[pocFields[1].name] ? "border-red-500" : ""}`}
                            />
                        </div>
                        {errors[pocFields[1].name] && <p className="text-red text-sm">{errors[pocFields[1].name].message}</p>}
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {pocFields[2].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="tel"
                                placeholder={pocFields[2].placeholder}
                                {...register(pocFields[2].name)}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[pocFields[2].name] ? "border-red-500" : ""}`}
                            />
                        </div>
                        {errors[pocFields[2].name] && <p className="text-red text-sm">{errors[pocFields[2].name].message}</p>}
                    </div>
                </div>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {pocFields[3].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="tel"
                                placeholder={pocFields[3].placeholder}
                                {...register(pocFields[3].name)}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[pocFields[3].name] ? "border-red-500" : ""}`}
                            />
                        </div>
                        {errors[pocFields[3].name] && <p className="text-red text-sm">{errors[pocFields[3].name].message}</p>}
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {pocFields[4].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="email"
                                placeholder={pocFields[4].placeholder}
                                {...register(pocFields[4].name)}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[pocFields[4].name] ? "border-red-500" : ""}`}
                            />
                        </div>
                        {errors[pocFields[4].name] && <p className="text-red text-sm">{errors[pocFields[4].name].message}</p>}
                    </div>
                </div>
            </FormSection>

            <FormSection title="Account Details" defaultExpanded={false}>
                <p>*Note: Password will be auto generated from the system</p>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {accountFields[0].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={accountFields[0].placeholder}
                                {...register(accountFields[0].name)}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[accountFields[0].name] ? "border-red-500" : ""}`}
                            />
                        </div>
                        {errors[accountFields[0].name] && <p className="text-red text-sm">{errors[accountFields[0].name].message}</p>}
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {accountFields[1].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={accountFields[1].placeholder}
                                {...register(accountFields[1].name)}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[accountFields[1].name] ? "border-red-500" : ""}`}
                            />
                        </div>
                        {errors[accountFields[1].name] && <p className="text-red text-sm">{errors[accountFields[1].name].message}</p>}
                    </div>
                </div>
                <div className="flex gap-1">
                    <div className="flex flex-col shrink-0 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {accountFields[2].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={accountFields[2].placeholder}
                                {...register(accountFields[2].name)}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[accountFields[2].name] ? "border-red-500" : ""}`}
                            />
                        </div>
                        {errors[accountFields[2].name] && <p className="text-red text-sm">{errors[accountFields[2].name].message}</p>}
                    </div>
                </div>
            </FormSection>

            <FormSection title="Organizational Details" defaultExpanded={false}>
                <div className="flex flex-col shrink-0 basis-0 w-full gap-1">
                    <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                        {organizationalFields[0].label}
                    </label>
                    <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                        <textarea
                            placeholder={organizationalFields[0].placeholder}
                            {...register(organizationalFields[0].name)}
                            className="flex-1 shrink self-stretch min-h-[100px] my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base min-h-[100px] resize-vertical"
                            rows={4}
                        />
                    </div>
                </div>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {organizationalFields[1].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={organizationalFields[1].placeholder}
                                {...register(organizationalFields[1].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {organizationalFields[2].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={organizationalFields[2].placeholder}
                                {...register(organizationalFields[2].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div>
                    </div>
                </div>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {organizationalFields[3].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={organizationalFields[3].placeholder}
                                {...register(organizationalFields[3].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {organizationalFields[4].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={organizationalFields[4].placeholder}
                                {...register(organizationalFields[4].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {organizationalFields[5].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={organizationalFields[5].placeholder}
                                {...register(organizationalFields[5].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div>
                    </div>
                </div>
                <div className="flex flex-col shrink-0 basis-0 w-full gap-1">
                    <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                        {organizationalFields[6].label}
                    </label>
                    <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                        <input
                            type="text"
                            placeholder={organizationalFields[6].placeholder}
                            {...register(organizationalFields[6].name)}
                            className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                        />
                    </div>
                </div>
            </FormSection>

            <FormSection title="Partnership Details" defaultExpanded={false}>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {partnershipFields[0].label}
                        </label>
                        <Select
                            options={partnershipFields[0].data}
                            isMulti={true}
                            placeholder="Select type of engagement"
                            classNamePrefix="select"
                            className='mt-1 text-base'
                            value={watchedTypesOfEngagement}
                            isClearable
                            isSearchable
                            name='eventsSection'
                            onChange={(selectedOptions) => {
                                setValue('typesOfEngagement', selectedOptions || []);
                            }}
                            noOptionsMessage={() => "No data available"}
                            components={{
                                MultiValue: ({ children, ...props }) => (
                                    <div className="flex items-center gap-1 bg-green-50 rounded px-2 py-1 m-1">
                                        <span className="text-green-700">{children}</span>
                                        <button
                                            onClick={() => props.removeProps.onClick()}
                                            className="ml-1 text-green-600 hover:text-green-800"
                                        >
                                            ×
                                        </button>
                                    </div>
                                ),
                            }}
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    backgroundColor: 'transparent',
                                    border: `1px solid ${errors.eventsSection ? 'red' : 'rgba(224, 230, 237, 1)'}`,
                                    borderRadius: '0.375rem',
                                    boxShadow: state.isFocused ? (errors.eventsSection ? '0 0 0 1px red' : '0 0 0 1px #16ad3c') : 'none',
                                    padding: '0.15rem',
                                    ":hover": {
                                        borderColor: errors.eventsSection ? 'red' : '#16ad3c',
                                    },
                                }),
                                menu: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                }),
                                option: (base, { isSelected }) => ({
                                    ...base,
                                    backgroundColor: isSelected ? '#16ad3c' : 'white',
                                    color: isSelected ? 'white' : 'black',
                                    ":active": {
                                        backgroundColor: isSelected ? '#16ad3c' : 'rgba(0, 0, 0, 0.1)',
                                    },
                                    ":hover": {
                                        backgroundColor: isSelected ? '#16ad3c' : 'rgba(52, 199, 89, 0.3)',
                                    },
                                }),
                                multiValue: (base) => ({
                                    ...base,
                                    backgroundColor: 'rgba(52, 199, 89, 0.1)',
                                    borderRadius: '4px',
                                }),
                                multiValueLabel: (base) => ({
                                    ...base,
                                    color: '#16ad3c',
                                }),
                                multiValueRemove: (base) => ({
                                    ...base,
                                    color: '#16ad3c',
                                    ':hover': {
                                        backgroundColor: 'rgba(52, 199, 89, 0.2)',
                                        color: '#16ad3c',
                                    },
                                }),
                            }}
                        />
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {partnershipFields[1].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="date"
                                {...register(partnershipFields[1].name)}
                                className={`flex-1 shrink self-stretch my-auto basis-1/3 outline-primary px-4 py-2.5 rounded-md text-base ${errors[partnershipFields[1].name] ? "border-red-500" : ""}`}
                            />
                        </div>
                        {errors[partnershipFields[1].name] && <p className="text-red text-sm">{errors[partnershipFields[1].name].message}</p>}
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {partnershipFields[2].label}
                        </label>
                        <div className="w-full bg-white rounded-md">
                            <textarea
                                placeholder={partnershipFields[2].placeholder}
                                {...register(partnershipFields[2].name)}
                                className="w-full min-h-[80px] outline-primary px-4 py-2.5 rounded-md text-base border border-solid border-navBtn"
                                rows={3}
                            />
                        </div>
                    </div>
                </div>
            </FormSection>

            <FormSection title="Tree Plantation Drives" defaultExpanded={false}>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {treePlantationFields[0].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={treePlantationFields[0].placeholder}
                                {...register(treePlantationFields[0].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {treePlantationFields[1].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <select
                                {...register(treePlantationFields[1].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            >
                                <option value="">{treePlantationFields[1].placeholder}</option>
                                {treePlantationFields[1].data?.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.placeholder}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col shrink-0 basis-0 w-full gap-1">
                    <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                        {treePlantationFields[2].label}
                    </label>
                    <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                        <textarea
                            placeholder={treePlantationFields[2].placeholder}
                            {...register(treePlantationFields[2].name)}
                            className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base min-h-[100px] resize-vertical"
                            rows={4}
                        />
                    </div>
                </div>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {treePlantationFields[3].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="number"
                                placeholder={treePlantationFields[3].placeholder}
                                {...register(treePlantationFields[3].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {treePlantationFields[4].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="number"
                                placeholder={treePlantationFields[4].placeholder}
                                {...register(treePlantationFields[4].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {treePlantationFields[5].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={treePlantationFields[5].placeholder}
                                {...register(treePlantationFields[5].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div>
                    </div>
                </div>
            </FormSection>

            <FormSection title="Food Distribution Drives" defaultExpanded={false}>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {foodDistributionFields[0].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={foodDistributionFields[0].placeholder}
                                {...register(foodDistributionFields[0].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {foodDistributionFields[1].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <select
                                {...register(foodDistributionFields[1].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            >
                                <option value="">{foodDistributionFields[1].placeholder}</option>
                                {foodDistributionFields[1].data?.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.placeholder}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col shrink-0 basis-0 w-full gap-1">
                    <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                        {foodDistributionFields[2].label}
                    </label>
                    <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                        <textarea
                            placeholder={foodDistributionFields[2].placeholder}
                            {...register(foodDistributionFields[2].name)}
                            className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base min-h-[100px] resize-vertical"
                            rows={4}
                        />
                    </div>
                </div>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {foodDistributionFields[3].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="number"
                                placeholder={foodDistributionFields[3].placeholder}
                                {...register(foodDistributionFields[3].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {foodDistributionFields[4].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="number"
                                placeholder={foodDistributionFields[4].placeholder}
                                {...register(foodDistributionFields[4].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div>
                    </div>
                </div>
            </FormSection>

            <FormSection title="Events" defaultExpanded={false}>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {eventFields[0].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <select
                                {...register(eventFields[0].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            >
                                <option value="">{eventFields[0].placeholder}</option>
                                {eventFields[0].data?.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.placeholder}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {eventFields[1].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <select
                                {...register(eventFields[1].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            >
                                <option value="">{eventFields[1].placeholder}</option>
                                {eventFields[1].data?.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.placeholder}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {eventFields[2].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={eventFields[2].placeholder}
                                {...register(eventFields[2].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div>
                    </div>
                </div>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/2 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {eventFields[3].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={eventFields[3].placeholder}
                                {...register(eventFields[3].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div>
                    </div>
                </div>
                <div className="flex flex-col shrink-0 basis-0 w-full gap-1">
                    <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                        {eventFields[4].label}
                    </label>
                    <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                        <textarea
                            placeholder={eventFields[4].placeholder}
                            {...register(eventFields[4].name)}
                            className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base min-h-[100px] resize-vertical"
                            rows={4}
                        />
                    </div>
                </div>
            </FormSection>            <FormSection title="Compliance & Agreements" defaultExpanded={false}>
                <div className="flex flex-col gap-6">
                    {/* Agreement Field */}
                    <div className="flex flex-col gap-2">
                        <label className="text-[14px] font-[600] text-gray-900">
                            Partnership Agreement Document
                        </label>
                        {watch('complianceAndAgreements.agreements') && Array.isArray(watch('complianceAndAgreements.agreements')) && watch('complianceAndAgreements.agreements').length > 0 && (
                            <div className="mt-2">
                                <p className="text-sm text-gray-600 mb-2">Uploaded Documents:</p>
                                {watch('complianceAndAgreements.agreements')
                                    .filter(url => url) // Filter out empty URLs
                                    .map((url, index) => (
                                        <div key={index} className="flex items-center gap-2 mb-1">
                                            <a
                                                href={url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-primary hover:underline text-sm"
                                            >
                                                View Document {index + 1}
                                            </a>
                                        </div>
                                    ))}
                            </div>
                        )}
                    </div>

                    {/* Signed Partnership Agreement */}
                    <div className="flex flex-col gap-2">
                        <label className="text-[14px] font-[600] text-gray-900">
                            Signed Partnership Agreement Or Terms And Conditions Acceptance
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <textarea
                                placeholder="Enter signed partnership agreement or terms and conditions acceptance details"
                                {...register('complianceAndAgreements.signedPartnershipAgreementOrTermsAndConditionsAcceptance')}
                                className="w-full min-h-[100px] outline-primary px-4 py-2.5 rounded-md text-base border-none resize-none"
                            />
                        </div>
                        {watch('complianceAndAgreements.signedPartnershipAgreementOrTermsAndConditionsAcceptance') && (
                            <div className="flex items-center gap-2 mt-2">
                                <span className="text-sm text-gray-600">
                                    Agreement details saved
                                </span>
                            </div>
                        )}
                    </div>

                    {/* Data Privacy Compliance Acknowledgment */}
                    <div className="flex flex-col gap-2">
                        <label className="text-[14px] font-[600] text-gray-900">
                            Data Privacy Compliance Acknowledgment
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <textarea
                                placeholder="Enter data privacy compliance acknowledgment details"
                                {...register('complianceAndAgreements.dataPrivacyComplianceAcknowledgment')}
                                className="w-full min-h-[100px] outline-primary px-4 py-2.5 rounded-md text-base border-none resize-none"
                            />
                        </div>
                    </div>

                    {/* File Upload Section for New Documents */}
                    <div className="border-t pt-4">
                        <FileHandler
                            label="Upload New Compliance Documents"
                            name="newComplianceDocuments"
                            value={watch('newComplianceDocuments') || []}
                            onChange={(files) => {
                                setValue('newComplianceDocuments', files);
                            }}
                            accept=".pdf,.doc,.docx"
                            multiple={true}
                            description="Upload compliance documents (PDF, DOC, DOCX)"
                        />
                    </div>
                </div>
            </FormSection>

            <FormSection title="Impact & Reporting" defaultExpanded={false}>
                <div key={impactFields[0].name} className="flex flex-col w-full gap-1">
                    <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                        {impactFields[0].label}
                    </label>
                    <Select
                        options={impactFields[0].data}
                        isMulti={true}
                        placeholder={impactFields[0].placeholder}
                        classNamePrefix="select"
                        className='mt-1 text-base'
                        value={watchedMetrics}
                        isClearable
                        isSearchable
                        name='eventsSection'
                        onChange={(selectedOptions) => {
                            setValue('metricsOrDataPointsTheyPlanToTrack', selectedOptions || []);
                        }}
                        noOptionsMessage={() => "No data available"}
                        components={{
                            MultiValue: ({ children, ...props }) => (
                                <div className="flex items-center gap-1 bg-green-50 rounded px-2 py-1 m-1">
                                    <span className="text-green-700">{children}</span>
                                    <button
                                        onClick={() => props.removeProps.onClick()}
                                        className="ml-1 text-green-600 hover:text-green-800"
                                    >
                                        ×
                                    </button>
                                </div>
                            ),
                        }}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                backgroundColor: 'transparent',
                                border: `1px solid ${errors.eventsSection ? 'red' : 'rgba(224, 230, 237, 1)'}`,
                                borderRadius: '0.375rem',
                                boxShadow: state.isFocused ? (errors.eventsSection ? '0 0 0 1px red' : '0 0 0 1px #16ad3c') : 'none',
                                padding: '0.15rem',
                                ":hover": {
                                    borderColor: errors.eventsSection ? 'red' : '#16ad3c',
                                },
                            }),
                            menu: (base) => ({
                                ...base,
                                zIndex: 9999,
                            }),
                            option: (base, { isSelected }) => ({
                                ...base,
                                backgroundColor: isSelected ? '#16ad3c' : 'white',
                                color: isSelected ? 'white' : 'black',
                                ":active": {
                                    backgroundColor: isSelected ? '#16ad3c' : 'rgba(0, 0, 0, 0.1)',
                                },
                                ":hover": {
                                    backgroundColor: isSelected ? '#16ad3c' : 'rgba(52, 199, 89, 0.3)',
                                },
                            }),
                            multiValue: (base) => ({
                                ...base,
                                backgroundColor: 'rgba(52, 199, 89, 0.1)',
                                borderRadius: '4px',
                            }),
                            multiValueLabel: (base) => ({
                                ...base,
                                color: '#16ad3c',
                            }),
                            multiValueRemove: (base) => ({
                                ...base,
                                color: '#16ad3c',
                                ':hover': {
                                    backgroundColor: 'rgba(52, 199, 89, 0.2)',
                                    color: '#16ad3c',
                                },
                            }),
                        }}
                    />
                </div>
                <div className="flex gap-3">
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {impactFields[1].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <select
                                {...register(impactFields[1].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            >
                                <option value="">{impactFields[1].placeholder}</option>
                                {impactFields[1].data?.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.placeholder}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {impactFields[2].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={impactFields[2].placeholder}
                                {...register(impactFields[2].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col shrink-0 basis-1/3 w-full gap-1">
                        <label className="gap-1 self-stretch text-[14px] w-full text-gray-900 font-[600] capitalize">
                            {impactFields[3].label}
                        </label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder={impactFields[3].placeholder}
                                {...register(impactFields[3].name)}
                                className="flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base"
                            />
                        </div>
                    </div>
                </div>
            </FormSection>

            <div className="flex mt-5 justify-between">
                <ActionButton
                    variant={'reset'}
                    text={'Reset Form'}
                    onClick={() => reset()}
                />
                <div className="flex gap-5">
                    <ActionButton
                        variant={'cancel'}
                        text={'Cancel'}
                        onClick={() => navigate('/user/list/ngos')}
                    />
                    <ActionButton
                        variant={'submit'}
                        text={isSubmitting ? 'Saving...' : 'Save'}
                        disabled={isSubmitting}
                        type="submit"
                    />
                    <ActionButton
                        variant={'submit'}
                        text={'Save and Register'}
                        type="button"
                        disabled={isSendingCredentials}
                        onClick={handleSaveAndSendCred}
                    />
                </div>
            </div>
            <ToastContainer position="top-right" autoClose={1000} />
        </form>
    );
};

export default NgoForm;
